module.exports = "/_next/static/images/RealTimeAudience@2x-a7f04a355c665425f88022bbcd38d5f1.png";